import { User } from '@/interfaces';
import { setUser } from '@/features/auth';
import { baseSplitApi } from '@/services';

export const userApi = baseSplitApi.injectEndpoints({
  endpoints: build => ({
    userSelf: build.query<User,undefined>({
      query: args => ({
        url: '/v1/user/self',
        method: 'GET',
      }),
      transformErrorResponse: (
        response: {status: string | number},
        meta,
        arg,
      ) => response.status,
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        const response = await queryFulfilled;
        dispatch(setUser(response.data));
      },      
      transformResponse: (response: {data: User}, meta, arg) => response.data,
    }),
    createUser: build.mutation<User, Partial<User>>({
      query: (body: Partial<User>) => ({
        url: `/v1/user/create-customer`,
        method: 'Post',
        body,
      }),
      transformResponse: (response: {data: User}) => response.data,
    }),
    updateUser: build.mutation<User, Partial<User>>({
      query: (body: Partial<User>) => ({
        url: `/v1/user`,
        method: 'Patch',
        body,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        const response = await queryFulfilled;
        dispatch(setUser(response.data));
      },
      transformResponse: (response: {data: User}) => response.data,
    }),
    deleteUser: build.mutation<any, null>({
      query: () => ({
        url: `/v1/user`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyUserSelfQuery,
  useUserSelfQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useCreateUserMutation,
} = userApi;
